// Certificate Links Configuration
// Update the Google Drive links here when you have them ready

export const certificateLinks = {
  deepLearning: {
    driveLink: '#', // Update with your Google Drive link for Deep Learning certificate
    previewImage: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=600&h=400&fit=crop&crop=center',
  },
  databaseManagement: {
    driveLink: '#', // Update with your Google Drive link
    previewImage: 'https://images.pexels.com/photos/1181677/pexels-photo-1181677.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  },
  dataMining: {
    driveLink: '#', // Update with your Google Drive link
    previewImage: 'https://images.pexels.com/photos/669610/pexels-photo-669610.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  },
  // Legacy support
  webDevelopment: {
    driveLink: '#',
    previewImage: 'https://images.pexels.com/photos/11035380/pexels-photo-11035380.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  },
};

// Instructions for Google Drive links:
// 1. Upload your certificate to Google Drive
// 2. Right-click on the file and select "Get link"
// 3. Make sure it's set to "Anyone with the link can view"
// 4. Copy the link and replace the '#' above
// 5. For better preview, you can also update the previewImage with a screenshot of your certificate